"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnProcessableEntityHttpError = void 0;
const http_status_codes_1 = __importDefault(require("http-status-codes"));
const AuthHttpError_1 = require("../../Error/Http/AuthHttpError");
class UnProcessableEntityHttpError extends AuthHttpError_1.AuthHttpError {
    constructor(message, key) {
        super(http_status_codes_1.default.UNPROCESSABLE_ENTITY, message, key);
    }
}
exports.UnProcessableEntityHttpError = UnProcessableEntityHttpError;
//# sourceMappingURL=UnProcessableEntityHttpError.js.map